import loadable from '@loadable/component';

export const CmsCategoryHighlightBlockLoadable = loadable(
  () => import('./CmsCategoryHighlightBlock'),
  { resolveComponent: (module) => module.CmsCategoryHighlightBlock },
);
